export const V6_SIGNUP_PAGE = 'onboarding/V6_SIGNUP_PAGE'
export const V6_EMAIL_PAGE = 'onboarding/V6_EMAIL_PAGE'
export const V6_COMPANY_PAGE = 'onboarding/V6_COMPANY_PAGE'
export const V6_COMPANY_2_PAGE = 'onboarding/V6_COMPANY_2_PAGE'
export const V6_VERIFICATION_PAGE = 'onboarding/V6_VERIFICATION_PAGE'
